
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal
} = require('@prisma/client/runtime/index-browser')


const Prisma = {}

exports.Prisma = Prisma

/**
 * Prisma Client JS version: 3.15.2
 * Query Engine version: 461d6a05159055555eb7dfb337c9fb271cbd4d7e
 */
Prisma.prismaVersion = {
  client: "3.15.2",
  engine: "461d6a05159055555eb7dfb337c9fb271cbd4d7e"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
)}
Prisma.validator = () => (val) => val

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = 'DbNull'
Prisma.JsonNull = 'JsonNull'
Prisma.AnyNull = 'AnyNull'

/**
 * Enums
 */
// Based on
// https://github.com/microsoft/TypeScript/issues/3192#issuecomment-261720275
function makeEnum(x) { return x; }

exports.Prisma.UserScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  email: 'email'
});

exports.Prisma.SessionScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt',
  handle: 'handle',
  hashedSessionToken: 'hashedSessionToken',
  antiCSRFToken: 'antiCSRFToken',
  publicData: 'publicData',
  privateData: 'privateData',
  userId: 'userId'
});

exports.Prisma.TokenScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  hashedToken: 'hashedToken',
  type: 'type',
  expiresAt: 'expiresAt',
  sentTo: 'sentTo',
  userId: 'userId'
});

exports.Prisma.AccountScalarFieldEnum = makeEnum({
  id: 'id',
  provider: 'provider',
  providerId: 'providerId',
  origin: 'origin',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  scopes: 'scopes',
  accessExpiresAt: 'accessExpiresAt',
  cachedProfile: 'cachedProfile',
  userId: 'userId'
});

exports.Prisma.BannedAccountScalarFieldEnum = makeEnum({
  id: 'id',
  provider: 'provider',
  providerId: 'providerId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.BannedEmailScalarFieldEnum = makeEnum({
  id: 'id',
  email: 'email',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.AddressScalarFieldEnum = makeEnum({
  id: 'id',
  address: 'address',
  ensAddress: 'ensAddress',
  lastVerified: 'lastVerified',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.OrgScalarFieldEnum = makeEnum({
  id: 'id',
  slug: 'slug',
  guildId: 'guildId',
  cachedGuild: 'cachedGuild',
  guildCachedAt: 'guildCachedAt',
  svixAppId: 'svixAppId',
  preferences: 'preferences',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  customDomain: 'customDomain',
  entryRoleId: 'entryRoleId'
});

exports.Prisma.RoleScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  color: 'color',
  orgId: 'orgId',
  discordRoleId: 'discordRoleId',
  expression: 'expression',
  args: 'args',
  propagationMode: 'propagationMode',
  source: 'source',
  noblePermission: 'noblePermission',
  singletonKey: 'singletonKey',
  privacyLevel: 'privacyLevel',
  requirementsPrivacyLevel: 'requirementsPrivacyLevel',
  countPrivacyLevel: 'countPrivacyLevel',
  holdersPrivacyLevel: 'holdersPrivacyLevel',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.DiscordRoleScalarFieldEnum = makeEnum({
  id: 'id',
  deletedAt: 'deletedAt',
  cachedAt: 'cachedAt',
  data: 'data',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.UserRoleScalarFieldEnum = makeEnum({
  id: 'id',
  userId: 'userId',
  roleId: 'roleId',
  shouldPropagate: 'shouldPropagate',
  status: 'status',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.MemberScalarFieldEnum = makeEnum({
  id: 'id',
  userId: 'userId',
  orgId: 'orgId',
  preferences: 'preferences',
  cachedGuildMember: 'cachedGuildMember',
  guildMemberCachedAt: 'guildMemberCachedAt',
  noblePermission: 'noblePermission',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  active: 'active'
});

exports.Prisma.RequirementScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  args: 'args',
  description: 'description',
  creatorOrgId: 'creatorOrgId',
  creatorUserId: 'creatorUserId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt'
});

exports.Prisma.RequirementCheckScalarFieldEnum = makeEnum({
  id: 'id',
  requirementId: 'requirementId',
  userId: 'userId',
  status: 'status',
  meta: 'meta',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.TransactionScalarFieldEnum = makeEnum({
  id: 'id',
  hash: 'hash',
  from: 'from',
  to: 'to',
  value: 'value',
  source: 'source',
  network: 'network',
  asset: 'asset',
  blockNum: 'blockNum',
  data: 'data',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.CaptchaCompletionScalarFieldEnum = makeEnum({
  id: 'id',
  captchaToken: 'captchaToken',
  userId: 'userId',
  sessionHandle: 'sessionHandle',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  success: 'success'
});

exports.Prisma.BrightIDVerificationScalarFieldEnum = makeEnum({
  id: 'id',
  context: 'context',
  contextId: 'contextId',
  addressId: 'addressId',
  sessionHandle: 'sessionHandle',
  orgId: 'orgId',
  verificationJobId: 'verificationJobId',
  verificationJobStartedAt: 'verificationJobStartedAt',
  status: 'status',
  response: 'response',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.BrightIDSponsorshipScalarFieldEnum = makeEnum({
  id: 'id',
  brightIDVerificationId: 'brightIDVerificationId',
  response: 'response',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.DiscordInviteScalarFieldEnum = makeEnum({
  id: 'id',
  code: 'code',
  expiresAt: 'expiresAt',
  guildId: 'guildId',
  cachedInvite: 'cachedInvite',
  sessionHandle: 'sessionHandle',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.FormSubmissionScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  formId: 'formId',
  submissionId: 'submissionId',
  submissionData: 'submissionData'
});

exports.Prisma.EmailScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  email: 'email',
  verified: 'verified'
});

exports.Prisma.PhoneNumberScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  userId: 'userId',
  mobile: 'mobile',
  verified: 'verified'
});

exports.Prisma.CacheScalarFieldEnum = makeEnum({
  key: 'key',
  value: 'value',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  lastUsedAt: 'lastUsedAt',
  countUsed: 'countUsed'
});

exports.Prisma.HookValueScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  orgId: 'orgId',
  userId: 'userId',
  address: 'address',
  key: 'key',
  value: 'value'
});

exports.Prisma.OrgXGoogleOrgScalarFieldEnum = makeEnum({
  orgId: 'orgId',
  googleOrgId: 'googleOrgId',
  adminId: 'adminId',
  preferences: 'preferences',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.GoogleOrgScalarFieldEnum = makeEnum({
  id: 'id',
  name: 'name',
  clientId: 'clientId',
  clientSecret: 'clientSecret',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.GoogleGroupScalarFieldEnum = makeEnum({
  id: 'id',
  groupKey: 'groupKey',
  googleOrgId: 'googleOrgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  roleId: 'roleId'
});

exports.Prisma.TheGraphSnapshotScalarFieldEnum = makeEnum({
  id: 'id',
  queryHash: 'queryHash',
  queryResults: 'queryResults',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.DuneSnapshotScalarFieldEnum = makeEnum({
  id: 'id',
  queryId: 'queryId',
  resultId: 'resultId',
  columnName: 'columnName',
  metadata: 'metadata',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.DuneRowScalarFieldEnum = makeEnum({
  id: 'id',
  rowNumber: 'rowNumber',
  cellData: 'cellData',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  duneSnapshotId: 'duneSnapshotId'
});

exports.Prisma.NotionBotCookieScalarFieldEnum = makeEnum({
  id: 'id',
  cookie: 'cookie',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.NotionPageScalarFieldEnum = makeEnum({
  id: 'id',
  notionPageId: 'notionPageId',
  orgId: 'orgId',
  staticRoleId: 'staticRoleId',
  editRoleId: 'editRoleId',
  commentRoleId: 'commentRoleId',
  viewRoleId: 'viewRoleId',
  metadata: 'metadata',
  cachedAt: 'cachedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.MemberAccountScalarFieldEnum = makeEnum({
  id: 'id',
  memberId: 'memberId',
  accountId: 'accountId',
  visibility: 'visibility',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.MemberAddressScalarFieldEnum = makeEnum({
  id: 'id',
  memberId: 'memberId',
  addressId: 'addressId',
  visibility: 'visibility',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.LoginTokenScalarFieldEnum = makeEnum({
  id: 'id',
  provider: 'provider',
  providerId: 'providerId',
  orgId: 'orgId',
  token: 'token',
  usedAt: 'usedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.TelegramTokenScalarFieldEnum = makeEnum({
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  token: 'token',
  usedAt: 'usedAt',
  inviteLink: 'inviteLink',
  userId: 'userId',
  telegramGroupId: 'telegramGroupId'
});

exports.Prisma.ContractMetadataScalarFieldEnum = makeEnum({
  id: 'id',
  contract: 'contract',
  network: 'network',
  name: 'name',
  symbol: 'symbol',
  logo: 'logo',
  decimals: 'decimals',
  openseaCollection: 'openseaCollection',
  standard: 'standard',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.DiscordChannelScalarFieldEnum = makeEnum({
  id: 'id',
  guildId: 'guildId',
  singletonKey: 'singletonKey',
  guildChannelId: 'guildChannelId',
  guildEntryRole: 'guildEntryRole',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.TelegramGroupScalarFieldEnum = makeEnum({
  id: 'id',
  chatId: 'chatId',
  metadata: 'metadata',
  roleId: 'roleId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.DiscordMessageScalarFieldEnum = makeEnum({
  id: 'id',
  interactionName: 'interactionName',
  guildId: 'guildId',
  messageId: 'messageId',
  channelId: 'channelId',
  messageIdentifier: 'messageIdentifier',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.FeatureFlagScalarFieldEnum = makeEnum({
  id: 'id',
  key: 'key',
  status: 'status',
  userId: 'userId',
  orgId: 'orgId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
});

exports.Prisma.SortOrder = makeEnum({
  asc: 'asc',
  desc: 'desc'
});

exports.Prisma.JsonNullValueInput = makeEnum({
  JsonNull: 'JsonNull'
});

exports.Prisma.NullableJsonNullValueInput = makeEnum({
  DbNull: 'DbNull',
  JsonNull: 'JsonNull'
});

exports.Prisma.QueryMode = makeEnum({
  default: 'default',
  insensitive: 'insensitive'
});

exports.Prisma.JsonNullValueFilter = makeEnum({
  DbNull: 'DbNull',
  JsonNull: 'JsonNull',
  AnyNull: 'AnyNull'
});
exports.AccountProvider = makeEnum({
  twitter: 'twitter',
  discord: 'discord',
  nifty: 'nifty',
  google: 'google',
  telegram: 'telegram',
  conde: 'conde'
});

exports.AccountOrigin = makeEnum({
  oauth: 'oauth',
  oauth1: 'oauth1',
  otp: 'otp'
});

exports.PropagationMode = makeEnum({
  ON: 'ON',
  OFF: 'OFF'
});

exports.RoleSource = makeEnum({
  expression: 'expression',
  discord: 'discord'
});

exports.NobleRolePermission = makeEnum({
  ADMIN: 'ADMIN',
  MEMBER: 'MEMBER'
});

exports.PrivacyLevel = makeEnum({
  public: 'public',
  user_public: 'user_public',
  user_member: 'user_member',
  holders: 'holders',
  private: 'private'
});

exports.MemberCheckStatus = makeEnum({
  PENDING: 'PENDING',
  APPROVED: 'APPROVED',
  DENIED: 'DENIED'
});

exports.TransactionSource = makeEnum({
  alchemyGet: 'alchemyGet',
  alchemyNotify: 'alchemyNotify'
});

exports.BrightIDVerificationStatus = makeEnum({
  PENDING: 'PENDING',
  EXPIRED: 'EXPIRED',
  WAITING_SPONSORSHIP: 'WAITING_SPONSORSHIP',
  NOT_LINKED: 'NOT_LINKED',
  WAITING_VERIFICATION: 'WAITING_VERIFICATION',
  ERROR: 'ERROR',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED'
});

exports.ConnectionVisibility = makeEnum({
  HIDDEN: 'HIDDEN',
  CHECK: 'CHECK',
  EXPOSE: 'EXPOSE'
});

exports.TokenStandard = makeEnum({
  ERC165: 'ERC165',
  ERC721: 'ERC721',
  ERC1155: 'ERC1155',
  ERC20: 'ERC20'
});

exports.FeatureStatus = makeEnum({
  on: 'on',
  backend: 'backend',
  off: 'off'
});

exports.Prisma.ModelName = makeEnum({
  User: 'User',
  Session: 'Session',
  Token: 'Token',
  Account: 'Account',
  BannedAccount: 'BannedAccount',
  BannedEmail: 'BannedEmail',
  Address: 'Address',
  Org: 'Org',
  Role: 'Role',
  DiscordRole: 'DiscordRole',
  UserRole: 'UserRole',
  Member: 'Member',
  Requirement: 'Requirement',
  RequirementCheck: 'RequirementCheck',
  Transaction: 'Transaction',
  CaptchaCompletion: 'CaptchaCompletion',
  BrightIDVerification: 'BrightIDVerification',
  BrightIDSponsorship: 'BrightIDSponsorship',
  DiscordInvite: 'DiscordInvite',
  FormSubmission: 'FormSubmission',
  Email: 'Email',
  PhoneNumber: 'PhoneNumber',
  Cache: 'Cache',
  HookValue: 'HookValue',
  OrgXGoogleOrg: 'OrgXGoogleOrg',
  GoogleOrg: 'GoogleOrg',
  GoogleGroup: 'GoogleGroup',
  TheGraphSnapshot: 'TheGraphSnapshot',
  DuneSnapshot: 'DuneSnapshot',
  DuneRow: 'DuneRow',
  NotionBotCookie: 'NotionBotCookie',
  NotionPage: 'NotionPage',
  MemberAccount: 'MemberAccount',
  MemberAddress: 'MemberAddress',
  LoginToken: 'LoginToken',
  TelegramToken: 'TelegramToken',
  ContractMetadata: 'ContractMetadata',
  DiscordChannel: 'DiscordChannel',
  TelegramGroup: 'TelegramGroup',
  DiscordMessage: 'DiscordMessage',
  FeatureFlag: 'FeatureFlag'
});

/**
 * Create the Client
 */
class PrismaClient {
  constructor() {
    throw new Error(
      `PrismaClient is unable to be run in the browser.
In case this error is unexpected for you, please report it in https://github.com/prisma/prisma/issues`,
    )
  }
}
exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
